import {Injectable} from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import {from, Observable, Subscription} from 'rxjs';
import {
  Config,
  getConfig,
  initialConfigState,
  updateMandate,
  updateMandateId
} from "../modules/redux";
import {Location} from "@angular/common";
import {ToastrService} from "ngx-toastr";
import {AppConfigService} from "../services";
import {Store} from "@ngrx/store";
import {MandateService} from "../modules/mandates/services";

@Injectable({
  providedIn: 'root'
})
export class MandateResolver implements Resolve<boolean> {
  private readonly LOGIN_PATH = '/auth/login';
  config$: Subscription = new Subscription();
  config: Config = initialConfigState;

  constructor(
    private router: Router,
    private location: Location,
    private toastr: ToastrService,
    private mandateService: MandateService,
    private appConfig: AppConfigService,
    private store: Store
  ) {
    this.config$ = this.store.select(getConfig).subscribe((config: Config) => {
      this.config = config;
    });

  }

  ngOnDestroy() {
    this.config$.unsubscribe();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return from(this.fetchAndDispatchMandate(route, state));
  }

  private fetchAndDispatchMandate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      let mandateId = route.paramMap.get('id') || '';
      this.mandateService.getMandate(mandateId).subscribe({
        next: (mandate: any) => {
          this.store.dispatch(updateMandateId({mandateId: mandateId}));
          this.store.dispatch(updateMandate({mandate: mandate}));
          resolve(true);
        }, error: err => {
          reject(false);
          let redirect = '/' + this.config.selected_business_unit.slug + '/mandates/';
          this.router.navigate([redirect]).then(() => {
            this.toastr.error("Access denied!", $localize`:@@companyName:Rondeivu`);
          });
        }
      });
    });
  }
}
